import { Pipe, PipeTransform } from '@angular/core';
import { OutlookAttachmentDetails } from '../models/outlook-attachment-details.model';

@Pipe({
    name: 'filterInlineAttachments',
})
export class FilterInlineAttachmentsPipe implements PipeTransform {
    transform(attachments): OutlookAttachmentDetails[] {
        if (attachments && attachments.length) {
            return attachments.filter((attachment) => {
                return !attachment.isInline;
            });
        } else {
            return [];
        }
    }
}
